var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkGreenSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "#1E9771"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#1E9771"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.636 5.76965C18.4842 5.84555 18.3324 5.99735 18.1806 6.14915C15.3723 8.95744 12.64 11.6898 9.83167 14.4981C9.75577 14.574 9.67987 14.7258 9.52807 14.8017C9.37627 14.6499 9.30037 14.574 9.22447 14.4981C8.08597 13.3596 6.94748 12.2211 5.80898 11.0826C5.73308 11.0067 5.58128 10.8549 5.50538 10.779C4.97408 10.3995 4.21509 10.3995 3.68379 10.779C2.84889 11.4621 2.84889 12.5247 3.68379 13.2837C5.27768 14.8776 6.87158 16.3956 8.38957 17.9895C8.54137 18.1413 8.61727 18.2172 8.76907 18.2931C9.45217 18.6726 10.0594 18.5208 10.6666 17.9136C13.9303 14.7258 17.118 11.4621 20.3817 8.27434C20.4576 8.19844 20.5335 8.12254 20.6094 8.04664C21.0648 7.51534 21.0648 6.52865 20.5335 5.99735C20.0781 5.46605 19.2432 5.31425 18.636 5.76965Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreenSquare);
export default __webpack_public_path__ + "static/media/checkmark-green-square.7c2d233e07b474ac132f7faf21376852.svg";
export { ForwardRef as ReactComponent };